import { SimulatedAdapter, type PlatformAdapter } from '@zrc/core';
import { ZoomSdkAdapter } from './zoomSdkAdapter.js';

export type AdapterKind = 'zoom' | 'simulated';

export function inZoomClient(): boolean {
  return typeof navigator !== 'undefined' && /ZoomApps|ZoomWebKit/i.test(navigator.userAgent);
}

/**
 * Pick the adapter: the real SDK inside the Zoom client, the simulator in a
 * plain browser or when ?sim=1 is set. The simulator is seeded with the gate
 * fixture's six names so the UI can be exercised end to end locally.
 */
export async function createAdapter(): Promise<{ kind: AdapterKind; adapter: PlatformAdapter }> {
  const params = new URLSearchParams(location.search);
  if (!params.has('sim') && inZoomClient()) {
    return { kind: 'zoom', adapter: await ZoomSdkAdapter.create() };
  }
  const sim = new SimulatedAdapter();
  for (const n of ['Dr Alice Cardio', 'Mr Ben Surgeon', 'Carla Student', 'Dev Student', 'Eve Student', 'Finn Student']) sim.join(n);
  (globalThis as { __sim?: SimulatedAdapter }).__sim = sim;
  return { kind: 'simulated', adapter: sim };
}
